"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var $ = require("jquery");
var baseViewModel_1 = require("./base/baseViewModel");
var ViewModel = (function (_super) {
    __extends(ViewModel, _super);
    function ViewModel(options) {
        _super.call(this, options);
        this.userName = options.userName;
    }
    ViewModel.prototype.submit = function () {
        var params = {};
        params.format = $("[name='format']").val();
        params.form = $("[name='form']").val();
        params.sorting = $("[name='sorting']").val();
        params.query = $("[name='query']").val();
        params.byContributor = $("[name='byContributor']").is(":checked");
        var genres = $("[name='genres']").val();
        params.genres = genres && genres.length > 0 ? genres.join(",") : "all";
        location.href = app.rootUrl + "u/" + this.userName + "/works?" + $.param(params);
    };
    return ViewModel;
}(baseViewModel_1.default));
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ViewModel;
//# sourceMappingURL=publisherProfileWorks.js.map